import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button, Tab, Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./hire-developer.css";
import { useAppContext } from "../../context/app-context";

const HireTeam = ({ isMegaMenu }) => {
    const navigate = useNavigate();
    const { setSelectedNavItem, setTempSelectedTitle } = useAppContext();

    const services = [
        "Frontend",
        "Backend",
        "Mobile App",
        "Automation",
        "Artificial Intelligence",
        "Machine Learning",
        "DevOps",
        "Data Science",
        "Cloud"
    ];

    const serviceDetails = {
        Frontend: [
            {
                name: "Hire ReactJS Developer",
                url: "/services/hire_reactjs_developer",
            },
            {
                name: "Hire AngularJS Developer",
                url: "/services/hire_angular_developer",
            },
            {
                name: "Hire VueJS Developer",
                url: "/services/hire_VueJS_developer",
            },
            {
                name: "Hire UI/UX Developer",
                url: "/services/hire_UIUX_developer",
            },
        ],
        Backend: [
            {
                name: "Hire NodeJS Developer",
                url: "/services/hire_Nodejs_developer",
            },
            {
                name: "Hire GoLang Developer",
                url: "/services/hire_GoLang_developer",
            },
            {
                name: "Hire MERN Stack Developer",
                url: "/services/hire_MERN_stack_developer",
            },
            {
                name: "Hire MEAN Stack Developer",
                url: "/services/hire_MEAN_stack_developer",
            },
            {
                name: "Hire Fullstack Java Developer",
                url: "/services/hire_fullstack_java_developer",
            },
            {
                name: "Hire Fullstack Python Developer",
                url: "/services/hire_Python_Fullstack_developer",
            },
            {
                name: "Hire PHP Developer",
                url: "/services/hire_php_developer",
            },
            {
                name: "Hire WordPress Developer",
                url: "/services/hire_WordPress_developer",
            },
            {
                name: "Hire Moodle Developer",
                url: "/services/hire_moodle_developer",
            },
            {
                name: "Hire ASP.NET Developer",
                url: "/services/hire_aspnet_developer",
            },
        ],
        "Mobile App": [
            {
                name: "Hire iOS Developer",
                url: "/services/hire_ios_developer",
            },
            {
                name: "Hire Android Developer",
                url: "/services/hire_android_developer",
            },
            {
                name: "Hire React Native Developer",
                url: "/services/hire_reactnative_developer",
            },
            {
                name: "Hire Flutter Developer",
                url: "/services/hire_flutter_developer",
            },
            {
                name: "Hire Ionic Developer",
                url: "/services/hire_ionic_developer",
            },
            {
                name: "Hire Xamarin Developer",
                url: "/services/hire_xamarin_developer",
            },
        ],
        Automation: [
            {
                name: "Hire Manual QA Engineer",
                url: "/services/hire_manual_QA_engineer",
            },
            {
                name: "Hire Automation Test Engineer",
                url: "/services/hire_automation_test_engineer",
            },
            {
                name: "Hire Security Test Engineer",
                url: "/services/hire_security_test_engineer",
            },
            {
                name: "Hire RPA Developer",
                url: "/services/hire_rpa_developer",
            },
        ],
        DevOps: [
            {
                name: "Hire DevOps Engineer",
                url: "/services/hire_devops_engineer",
            },

        ],
        "Artificial Intelligence": [
            {
                name: "Hire Machine Learning Engineer",
                url: "/services/hire_ml_engineer",
            },
            {
                name: "Hire Blockchain Developer",
                url: "/services/hire_blockchain_developer",
            },
        ],
        "Machine Learning": [
            {
                name: "Hire Machine Learning Engineer",
                url: "/services/hire_ml_engineer",
            },
        ],
        "Data Science": [
            {
                name: "Hire Power BI Developer",
                url: "/services/hire_Power_BI_Developer",
            },
        ],
        Cloud: [
            {
                name: "Hire AWS Cloud Developer",
                url: "/services/hire_AWS_Cloud_developer",
            },
            {
                name: "Hire Azure Cloud Developer",
                url: "/services/hire_AZURE_Cloud_developer",
            },
            {
                name: "Hire GCP Cloud Developer",
                url: "/services/hire_GCP_Cloud_developer",
            },
        ],
    };


    const [activeService, setActiveService] = useState(services[0]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    const [openContent, setOpenContent] = useState({}); // State to track open content
    const sectionRef = useRef(null);
    const contentRef = useRef({}); // Ref for submenu content

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1200);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleContent = (service) => {
        setOpenContent((prevState) => {
            return {
                [service]: !prevState?.[service],
            };
        });
        // Wait for the state to update and the ref to be set before scrolling
        setTimeout(() => {
            if (contentRef.current[service]) {
                contentRef.current[service].scrollIntoView({ behavior: "smooth" });
            }
        }, 0);
    };
    const handleServiceClick = (service) => {
        setActiveService(service);
        toggleContent(service);
        sectionRef.current?.scrollIntoView({ behavior: "smooth" }); // Scroll the section into view
    };
    return (
        <section
            ref={sectionRef}
            className={`hire-team-section ${isMegaMenu ? "mega-menu-content" : ""}`}
        >
            <Container fluid>
                <Row>
                    <Col xs="12">
                        <Tab.Container id="left-tab" activeKey={activeService}>
                            <Row className="mt-0">
                                <Col xs="12" lg="5" className="border-end">
                                    <Nav
                                        variant="pills"
                                        className="flex-column gap-2 gap-lg-3 sub-menu-block"
                                    >
                                        {services.map((service, index) => (
                                            <React.Fragment key={index}>
                                                <Nav.Item>
                                                    <Nav.Link
                                                        eventKey={service}
                                                        className="text-start"
                                                        onClick={() => handleServiceClick(service)}
                                                    >
                                                        {service}
                                                        {/* {isMobile && (
                                                            <img
                                                                src={carretDown}
                                                                alt="carret"
                                                                className={`carret ${openContent[service] ? 'rotate-up' : ''}`}
                                                                loading="lazy"
                                                            />
                                                        )} */}
                                                    </Nav.Link>
                                                </Nav.Item>
                                                {isMobile && openContent[service] && (
                                                    <Tab.Content
                                                        className="mobile-tab-content pt-0 mt-0"
                                                        ref={(el) => (contentRef.current[service] = el)}
                                                    >
                                                        <Tab.Pane eventKey={service}>
                                                            <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
                                                                {serviceDetails[service]?.map((detail, idx) => (
                                                                    <li key={idx}>
                                                                        <Button
                                                                            variant="link"
                                                                            className="text-uppercase fw-normal"
                                                                            onClick={() => {
                                                                                navigate(detail.url);
                                                                                setSelectedNavItem("hireTeam");
                                                                                setTempSelectedTitle("");
                                                                            }}
                                                                        >
                                                                            {detail.name}
                                                                        </Button>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </Tab.Pane>
                                                    </Tab.Content>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </Nav>
                                </Col>
                                {!isMobile && (
                                    <Col xs="12" lg="7">
                                        <Tab.Content>
                                            {services.map((service, index) => (
                                                <Tab.Pane eventKey={service} key={index}>
                                                    <ul className="list-unstyled d-flex flex-column gap-2">
                                                        {serviceDetails[service]?.map((detail, idx) => (
                                                            <li key={idx}>
                                                                <Button
                                                                    variant="link"
                                                                    className="text-uppercase fw-normal"
                                                                    onClick={() => {
                                                                        navigate(detail.url);
                                                                        setSelectedNavItem("hireTeam");
                                                                        setTempSelectedTitle("");
                                                                    }}
                                                                >
                                                                    {detail.name}
                                                                </Button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </Tab.Pane>
                                            ))}
                                        </Tab.Content>
                                    </Col>
                                )}
                            </Row>
                        </Tab.Container>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default HireTeam;
